import { render, staticRenderFns } from "./IdTagCards.vue?vue&type=template&id=458b2748&scoped=true&"
import script from "./IdTagCards.vue?vue&type=script&lang=ts&"
export * from "./IdTagCards.vue?vue&type=script&lang=ts&"
import style0 from "./IdTagCards.vue?vue&type=style&index=0&id=458b2748&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b2748",
  null
  
)

export default component.exports